// @flow

const AwsUsageSourceModal = () => {
  return null;
};

export default AwsUsageSourceModal;
